"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCategoryTree = useCategoryTree;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _searchTree = _interopRequireDefault(require("@deosite/helpers/searchTree"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CategoryTreeContext = /*#__PURE__*/_react["default"].createContext({});
function CategoryTreeProvider(_ref) {
  var tree = _ref.tree,
    children = _ref.children;
  var getCategoryNameForGivenCategoryId = function getCategoryNameForGivenCategoryId(id) {
    if (id === undefined) {
      return;
    }
    var result = getCategoryById(id);
    return result ? result.name : result;
  };
  var getCategoryById = function getCategoryById(id) {
    return (0, _searchTree["default"])(tree.categoryTree, id);
  };
  var getPath = function getPath(categoryId) {
    if (!categoryId) {
      return [];
    }
    var result;
    var categoryFound;
    tree.categoryTree.some(function (category) {
      result = (0, _searchTree["default"])(category, categoryId);
      categoryFound = category;
      return Object.keys(result).length > 0;
    });
    return result ? {
      categoryFound: categoryFound,
      categoryIds: result.path
    } : [];
  };
  var createBreadcrumbsPro = function createBreadcrumbsPro(categoryId) {
    if (!categoryId) {
      return [];
    }
    var _getPath = getPath(categoryId),
      categoryFound = _getPath.categoryFound,
      categoryIds = _getPath.categoryIds;
    var result = [];
    categoryIds.forEach(function (id) {
      var category = (0, _searchTree["default"])(categoryFound, id);
      var name = category.name,
        url = category.url,
        level = category.level;
      result.push({
        name: name,
        url: url,
        level: level,
        id: id
      });
    });
    return result;
  };
  var createBreadcrumbsPaths = function createBreadcrumbsPaths(path) {
    if (!path) {
      return;
    }
    var paths = [];
    var urlParts = path.split("/");
    var mainCategoryPath = urlParts[0] + "/" + urlParts[1];
    var treePart = tree.categoryTree.find(function (category) {
      if (category.url === mainCategoryPath) {
        paths.push({
          name: category.name,
          url: category.url
        });
        return category;
      }
    });
    if (urlParts.length < 3) {
      return paths;
    }
    treePart === null || treePart === void 0 ? void 0 : treePart.subcategories.find(function (category) {
      var subcategory = category.find(function (subcategory) {
        return subcategory.url === mainCategoryPath + "/" + urlParts[2];
      });
      if (subcategory) {
        paths.push({
          name: subcategory.name,
          url: subcategory.url
        });
        if (subcategory.subcategories.length > 0) {
          var lastCategory = subcategory.subcategories.find(function (category) {
            return category.url === mainCategoryPath + "/" + urlParts[2] + "/" + urlParts[3];
          });
          paths.push({
            name: lastCategory.name,
            url: lastCategory.url
          });
        }
        return true;
      }
    });
    return paths;
  };
  var chooseCategoryTree = function chooseCategoryTree(id) {
    var _treeFragment$subcate;
    var getTreeByIdPro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (id === undefined) {
      return;
    }
    var activeCategory = getCategoryById(id);
    if (!activeCategory) {
      return;
    }
    var urlParts = activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.url.split("/");
    var mainCategoryPath = urlParts[0] + "/" + urlParts[1];
    var treeFragment;
    if (getTreeByIdPro) {
      var _activeCategory$path;
      treeFragment = _objectSpread({}, getCategoryById((_activeCategory$path = activeCategory.path) === null || _activeCategory$path === void 0 ? void 0 : _activeCategory$path[0]));
    } else {
      var _tree$categoryTree$fi;
      treeFragment = (_tree$categoryTree$fi = tree.categoryTree.find(function (category) {
        return category.url === mainCategoryPath;
      })) !== null && _tree$categoryTree$fi !== void 0 ? _tree$categoryTree$fi : [];
    }
    var fixedSubcategories = [];
    (_treeFragment$subcate = treeFragment.subcategories) === null || _treeFragment$subcate === void 0 ? void 0 : _treeFragment$subcate.forEach(function (subcategory) {
      subcategory.forEach(function (singleSubcategory) {
        fixedSubcategories.push(singleSubcategory);
      });
    });
    treeFragment.subcategories = [];
    treeFragment.subcategories.push(fixedSubcategories);
    return {
      tree: treeFragment,
      parentId: activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.parentId,
      productCategoryId: id
    };
  };
  return __jsx(CategoryTreeContext.Provider, {
    value: {
      getCategoryNameForGivenCategoryId: getCategoryNameForGivenCategoryId,
      createBreadcrumbsPro: createBreadcrumbsPro,
      getCategoryById: getCategoryById,
      createBreadcrumbsPaths: createBreadcrumbsPaths,
      chooseCategoryTree: chooseCategoryTree
    }
  }, children);
}
function useCategoryTree() {
  return (0, _react.useContext)(CategoryTreeContext);
}
var _default = CategoryTreeProvider;
exports["default"] = _default;